import React from "react";
import { useNavigate } from "react-router-dom";
import Carousel from '../components/Carousel';
import './Home.css';

const Home = () => {
  const homeBanner = require('../assets/homeBanner.jpg');
  const joinUs = require('../assets/homepage_joinUs.jpg')
  const adoptbanner = require('../assets/adoptbanner.jpg')


  const navigate = useNavigate();

  function navigateAdoption() {
    navigate('/adoption')
  }

  function navigateSignUp() {
    navigate('/signup')
  }

  return (
    <>
      <div className="homepage">
        <section className="banner-container">
          <img src={homeBanner} alt="Home Banner" className="homeBanner" />
          <div className="overlay">
            <h1>Pet Heaven</h1>
            <h2>Love & Care For Every Paw!</h2>
            <button onClick={navigateAdoption}>Adopt Now!</button>
          </div>
        </section>

        <div className="aboutUs">
          <div className="card">
            <h3>Our Mission</h3>
            <p>To provide a safe and loving environment for every pet in need, and to find them a forever home.</p>
          </div>
          <div className="card">
            <h3>Our Vision</h3>
            <p>A world where every pet is treated with love, respect, and care, and where no pet is left behind.</p>
          </div>
          <div className="card">
            <h3>Our Values</h3>
            <p>Compassion, dedication, and integrity are at the heart of everything we do.</p>
          </div>
        </div>

        <div className="joinUs">
          <img src={joinUs} alt="Join Us" />
          <span>
            <h1>Join Us</h1>
            <p>Become a part of our community and help us make a difference in the lives of countless pets. Whether you want to volunteer, donate, or simply spread the word, your support is invaluable. Together, we can ensure that every pet finds a loving home and receives the care they deserve.</p>
            <button onClick={navigateSignUp}>Be a Volunteer!</button>
          </span>
        </div>

        <div>
        </div>
        {/* <Carousel/> */}
        <div className="adopt">
          <span>
            <h1> Adopt A Furry Friend </h1>
            <p>Pet Heaven is a shelter dedicated to the protection and care of domestic pets in Singapore</p>
            <button onClick={navigateAdoption}>Adoption Gallery!</button>
          </span>
          <img src={adoptbanner} alt="Adopt Banner" />
        </div>
      </div>
    
    </>
  );
};

export default Home;
